<script setup>
import {ref} from "vue";
import {ApiUrl, fetchApiBridge} from "@/utils";

const props = defineProps({
    imageUri: {
        type: String,
        required: true
    },
    variant: {
        type: String,
        default: "1300-500-dportal_teaser-media-news-events"
    }
})

const image = ref(null);

function checkEntityPath(url) {
    let path = url.split("/entity/");
    if (path.length !== 2) {
        return false;
    }
    return path[1];
}

let path = checkEntityPath(props.imageUri);
if (path) {
    if (typeof window.cardImages[path] !== "undefined") {
        image.value = window.cardImages[path];
    } else {
        fetchApiBridge("p=" + path, (res) => {
            window.cardImages[path] =
                ApiUrl +
                "CenshareBridge?p=" +
                checkEntityPath(res.variants[props.variant].link);
            image.value = window.cardImages[path];
        });
    }
}
</script>

<template>
    <img v-if="image" :src="image" alt=""/>
</template>
